import React from "react";

/**
 * RangeInputMC is a functional component that renders a customizable range input slider.
 *
 * @param {Object} props - The properties object.
 * @param {number} [props.min=0] - The minimum value of the range input.
 * @param {number} [props.max=100] - The maximum value of the range input.
 * @param {number} [props.step=1] - The step value for the range input.
 * @param {number} props.value - The current value of the range input.
 * @param {function} props.onChange - The function to call when the value changes.
 * @param {string} [props.className=''] - Additional class names for the container div.
 * @param {string} [props.inputClassName=''] - Additional class names for the input element.
 *
 * @returns {JSX.Element} The rendered range input component.
 */
const RangeInputMC = ({
  min = 0,
  max = 100,
  step = 1,
  value,
  onChange,
  className = '',
  inputClassName = ''
}) => (
  <div className="tw-wrapper">
    <div className={`tw-flex tw-flex-col tw-gap-2 ${className}`}>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onChange}
        className={`
            tw-w-full tw-h-[6px] tw-bg-gray-500 tw-rounded-lg tw-appearance-none tw-cursor-pointer
            tw-accent-gray-400
            [&::-webkit-slider-thumb]:tw-h-[18px]
            [&::-webkit-slider-thumb]:tw-w-[18px]
            [&::-moz-range-thumb]:tw-h-[18px]
            [&::-moz-range-thumb]:tw-w-[18px]
          [&::-webkit-slider-thumb]:tw-bg-gray-400
          [&::-moz-range-thumb]:tw-bg-gray-400
            [&::-webkit-slider-thumb]:tw-appearance-none 
            [&::-moz-range-thumb]:tw-appearance-none 
            [&::-moz-range-thumb]:tw-rounded-full
            [&::-webkit-slider-thumb]:tw-rounded-full 
            ${inputClassName}`}
      />
      <div className="tw-flex tw-justify-between tw-text-sm tw-font-medium">
        <span>{min}</span>
        <span>{value}</span>
        <span>{max}</span>
      </div>
    </div>
  </div>
);

export default RangeInputMC;
